import { ReducerState } from "../reducers/index";

import * as Server from "./server/index"

export type StoreState = ReducerState;
export type InitialData = Server.Login.LoginIndexResponse;
export type CorporateMessage = Server.Login.CorporateMessageResponse;
export type LoginResponse = Server.Login.LoginResponse;
export type Question = Server.Recovery.QuestionModelResponse;
export type Answer = Server.Recovery.AnswerSecretContract;

export namespace Mapper {
    export const Login = Server.Login;
}

export interface ResetPasswordResponse_Server {
    Data: boolean,
    Message: string,
    Status: string,
    IsSuccess: boolean,
}

export interface ResetPasswordResponse_Client {
    data: boolean,
    message: string,
    status: string,
    isSuccess: boolean,
}

export interface ValidateUserPassword_Contract_Client {
    username: string
    password: string
    confirmPassword: string
    
}

export interface ValidateUserPassword_Response_Server{ 
    TestName: string
    IsPassed: boolean
    
}
export interface ValidateUserPassword_Response_Client {
    test: string
    isPassed: boolean
    
}

export const map_ValidateUserPassword_Response = (data: ValidateUserPassword_Response_Server): ValidateUserPassword_Response_Client => {
    if(!data)
			return null;
    return {
        test: data.TestName,
        isPassed: data.IsPassed
	  
    }
}

export interface ValidateOldPassword_Contract_Client {
    username: string,
    oldPassword: string
}

export interface ChangeUserPassword_Contract_Client {
    OldPassword: string
    NewPassword: string
    ConfirmPassword: string
}

export interface ChangeUserPassword_Response_Server {
    Data: any,
    Message: string,
    ShowMessage: boolean,
    Status: string,
    ErrorList?: string[]
}

export interface ChangeUserPassword_Response_Client {
    data: any,
    message: string,
    showMessage: boolean,
    status: string
}

export const map_ChangeUserPassword_Response = (data: ChangeUserPassword_Response_Server): ChangeUserPassword_Response_Client => {
    if(!data)
			return null;
    return {
        data: data.Data,
        message: data.Message,
        showMessage: data.ShowMessage,
        status: data.Status
    }
}

export interface CheckSecretAnswersByUserName_Response_Server {
    QuestionId: string,
    QuestionText: string
}

export interface CheckSecretAnswersByUserName_Response_Client {
    questionId: string,
    questionText: string
}

export const map_CheckSecretAnswersByUserName_Response = (data: CheckSecretAnswersByUserName_Response_Server): CheckSecretAnswersByUserName_Response_Client => {
    return {
        questionId: data.QuestionId,
        questionText: data.QuestionText
    }
}

export interface SecretAnswer {
    answerId: string
    questionId: string
    answerText: string
}

export interface SecretAnswers_Contract {
    answers: SecretAnswer[]
}